import { initSentry, registerFeedbackHook } from '@platform/observability';
import { PAYMENT_SDK_HOSTS } from '@platform/payment/sdk-origins';
import { env } from '../../config/runtime';
import { DYNAMIC_IMPORT_ERROR_PATTERN } from './preloadErrorReload';

export function bootstrapSentry(router: Parameters<typeof initSentry>[0]['router']) {
  const environment = env.runtimeEnvironment ?? 'prod';

  registerFeedbackHook();

  initSentry({
    dsn: env.sentry?.dsn,
    tunnel: '/api/sentry/tunnel',
    enabled: env.sentry?.enabled ?? false,
    // Automated browsers get their own environment, so alert rules and dashboards can exclude them by
    // enumerating the real ones.
    environment: navigator.webdriver ? `${environment}-e2e` : environment,
    release: env.appVersion,
    app: 'hub',
    team: 'waipu-platform',
    applicationKey: 'waipu-hub',
    criticalVendors: PAYMENT_SDK_HOSTS,
    // A stale chunk after a deploy is recovered by a one-shot reload, not a crash.
    ignoreErrors: [DYNAMIC_IMPORT_ERROR_PATTERN],
    router,
  });
}
